var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function stripTrailingSlash(s) {
    return s.endsWith("/") ? s.slice(0, -1) : s;
}
function buildParams(base, overrides) {
    const params = new URLSearchParams(base);
    if (overrides) {
        for (const [k, v] of Object.entries(overrides)) {
            if (typeof v === "string")
                params.set(k, v); // ignore undefined
        }
    }
    return params;
}
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export function cleanQueryParams(query) {
    // remove leading ?
    const search = query.startsWith("?") ? query.slice(1) : query;
    // parse into URLSearchParams
    const usp = new URLSearchParams(search);
    // convert into entries
    const arr = Array.from(usp.entries());
    // deduplicate by key (keep first value)
    const seen = new Set();
    const obj = {};
    for (const [key, value] of arr) {
        if (!seen.has(key)) {
            seen.add(key);
            obj[key] = value;
        }
    }
    return obj;
}
export function fetchAllNews(BASE, DEFAULT_PARAMS, overrides) {
    return __awaiter(this, void 0, void 0, function* () {
        const endpoint = stripTrailingSlash(BASE);
        const params = buildParams(DEFAULT_PARAMS, overrides);
        const url = endpoint.includes("?")
            ? `${endpoint}&${params.toString()}`
            : `${endpoint}?${params.toString()}`;
        const ctrl = new AbortController();
        const timeout = setTimeout(() => ctrl.abort(), 10000);
        try {
            const res = yield fetch(url, {
                signal: ctrl.signal,
                headers: { Accept: "application/json" },
            });
            if (!res.ok)
                throw new Error(`HTTP ${res.status}`);
            return (yield res.json());
        }
        finally {
            clearTimeout(timeout);
        }
    });
}
